<template>
  <div class="container bg-hui">
    <div class="cash-out-box">
      <p>
        您今日可以提现了，今日提现不能超过{{data.dailyWithdrawCount}}次，提现总额不能超过{{data.dailyTotalWithdrawMoney}}元
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: {}
      };
    },
    mounted() {
      let data = decodeURIComponent(this.$route.query.data);
      console.log(data);
      this.data = JSON.parse(data);
      console.log(this.data);
    },
    methods: {},
  };
</script>
<style scoped lang="less">
  .cash-out-box {
    background: white;
    border-radius: 0.25rem;
    margin: 0.75rem;
    padding: 1rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 1.5rem;
  }
</style>

